import Link                from "next/link";
import React, { useState } from "react";

import Icon       from "_components/atoms/icon";
import Typography from "_components/atoms/typography";
import useStyles  from "_styles/pages/blogs/categorySection.js";

import CategoryPostLayout from "./categoryPostLayout";

const homePage = ( { category } ) => {
	const [ hover, setHover ] = useState ( false );
	const { classes }         = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.categoryContainer }>

			<div
				className    = { classes.headingWrapper }
				onMouseLeave = { () => {
					setHover ( false );
				} }
			>
				<div
					onMouseEnter = { () => {
						setHover ( true );
					} }
				>
					<Typography
						key       = { category?.id }
						className = { classes.categoryName }
						title     = { category?.name }
					/>
				</div>

				{hover && (
					<Link href = { `/blogs/${ category?.name }` }>
						<div className = { classes.hoverText }>
							<span className = { classes.animateText }>
								See More
								<Icon sameInBothTheme
									className = { classes.arrowIcon }
									name      = "arrowIconBlog"
								/>
							</span>

						</div>
					</Link>
				)}

			</div>

			<CategoryPostLayout
				category = { category }
			/>
		</div>
	);
};

export default homePage;